/* eslint-disable @typescript-eslint/no-explicit-any */
import { TrashIcon, UploadIcon } from '@/icons';
import { useEffect, FC } from 'react';
import BottomPanel from '@/components/BottomPanel';
import {
  BlankPage,
  deleteUserPage,
  getUserPages,
} from '@/database/userPageDatabaseService';
import { useTranslation } from 'react-i18next';
import { BookModel, DisplayTypes } from '@/types';
import { User } from '@/database/userDatabaseService';
import './index.scss';
interface SavedPagesProps {
  isOpen: boolean;
  user: User;
  book: BookModel;
  toggleSavedPage: () => void;
  blankPages: BlankPage[];
  dispatch: (action: any) => void;
  setBlankPages: (pages: BlankPage[]) => void;
  setCurrentBlankPage: (blankPage: BlankPage) => void;
  setDisplayType: (displayType: string) => void;
}

const SavedPages: FC<SavedPagesProps> = ({
  isOpen,
  toggleSavedPage,
  dispatch,
  user,
  book,
  blankPages,
  setBlankPages,
  setCurrentBlankPage,
  setDisplayType,
}) => {
  useEffect(() => {
    getUserPages(user.id, book.id).then((res) => {
      dispatch(setBlankPages(res));
    });
  }, [user.id, book.id, dispatch, setBlankPages]);

  const { t } = useTranslation('translation', { keyPrefix: 'footer' });

  const loadPage = (userPage: BlankPage) => {
    dispatch(setCurrentBlankPage(userPage));
    dispatch(setDisplayType(DisplayTypes.BlankPage));
  };

  const deletePage = (id: string) => {
    deleteUserPage(id).then(() => {
      const pages = blankPages?.filter((x) => x.id !== id);
      dispatch(setBlankPages(pages));
    });
  };

  const setIsOpen = ()=> toggleSavedPage();
  return (
    <BottomPanel isOpen={isOpen} title={t('pages')} setIsOpen={setIsOpen}>
      <div className="saved-pages">
        <div className="saved-page-list">
          {blankPages && blankPages
            .filter((x) => x.id)
            .map((userPage) => (
              <div key={userPage.id} className="saved-page-item">
                {userPage.dataUrl && (
                  <img
                    className="saved-page-thumbnail"
                    src={userPage.dataUrl}
                    alt="saved-page"
                  />
                )}
                <div className="saved-page-actions">
                  <button
                    className="obro-btn load-page-button"
                    onClick={() => loadPage(userPage)}
                  >
                    <UploadIcon className={undefined} color={undefined} />
                    {t('load_page')}
                  </button>
                  <button
                    className="obro-btn delete-page-btn"
                    onClick={() => userPage.id && deletePage(userPage.id)}
                  >
                    <TrashIcon className={undefined} color={undefined} />
                  </button>
                </div>
                <div className='page-info'>
                  <span className="saved-page-title">{userPage.title}</span>
                  <span className="saved-date">{userPage.createdDate}</span>
                </div>
              </div>
            ))}
        </div>
      </div>
    </BottomPanel>
  );
};

export default SavedPages;
